"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutModal = void 0;
const React = require("react");
const react_router_dom_1 = require("react-router-dom");
const react_1 = require("react");
const useRequiredContext_1 = require("../../../../../hooks/useRequiredContext");
const SalesOrderContext_1 = require("../../contexts/SalesOrderContext");
const Modal_1 = require("../../../../../components/base/structure/Modal");
const dialogs_1 = require("../../../../../types/dialogs");
const CheckoutFlowView_1 = require("../../views/CheckoutFlowView");
const OrderTypeContext_1 = require("../../contexts/OrderTypeContext");
const retailOrderingRoutes_1 = require("../../../../../apps/spg/ordering/components/RetailOrderingApp/retailOrderingRoutes");
const RetailEventTrackingContext_1 = require("../../contexts/RetailEventTrackingContext");
const TSalesOrderType_1 = require("../../types/TSalesOrderType");
const CheckoutModal = ({ show, dismiss }) => {
    const history = (0, react_router_dom_1.useHistory)();
    const { logTransaction, logPurchase } = (0, useRequiredContext_1.useRequiredContext)(RetailEventTrackingContext_1.RetailEventTrackingContext);
    const { orderType } = (0, useRequiredContext_1.useRequiredContext)(OrderTypeContext_1.OrderTypeContext);
    const { validateSalesOrder, processSalesOrder, processSalesOrderError, processingOrder, notes, temporaryAddress } = (0, useRequiredContext_1.useRequiredContext)(SalesOrderContext_1.SalesOrderContext);
    const [stage, setStage] = (0, react_1.useState)("");
    return (React.createElement(Modal_1.Modal, { open: show, onClose: processingOrder.current ? null : dismiss, size: dialogs_1.TDialogSizes.Large, appMode: true },
        React.createElement(Modal_1.ModalHeader, null, stage),
        React.createElement(Modal_1.ModalBody, null,
            React.createElement(CheckoutFlowView_1.CheckoutFlowView
            //validating the order server-side and setting up payment condition
            , { 
                //validating the order server-side and setting up payment condition
                validateOrder: options => validateSalesOrder(options, notes, orderType === TSalesOrderType_1.TSalesOrderType.Delivery && temporaryAddress), processOrder: (paymentToken, oneTimePayment) => processSalesOrder(paymentToken, oneTimePayment, notes, orderType === TSalesOrderType_1.TSalesOrderType.Delivery && temporaryAddress)
                    .then(salesOrder => {
                    if (salesOrder) {
                        // log details of sales order to GTM
                        logTransaction(salesOrder);
                        logPurchase(salesOrder);
                        dismiss();
                        history.push((0, retailOrderingRoutes_1.toSalesOrderSummary)(salesOrder.salesOrderId), history.location.pathname);
                    }
                })
                    .catch(console.log), processSalesOrderError: processSalesOrderError, onStageChange: stage => setStage(stage) }))));
};
exports.CheckoutModal = CheckoutModal;
//# sourceMappingURL=index.js.map